<template>
    <div class="outer-container" style="margin-top: 63px">
        <div class="hero">
            <div class="hero-ctn">
                <h1>Portfolio</h1>
                <p>{{ $t('portfolioDescriotion') }}</p>
            </div>
        </div>
        <div class="portfolio-container">
            <div class="category-portfolio-container">
                <div v-for="(category, index) in categoryList" :key="index" @click="getPortfolio(category.key)"
                    :class="currentCategory == category.key ? 'active' : 'inactive'">
                    {{ category.value }}
                </div>
            </div>
            <div class="card" v-if="projectPortfolio.length > 0">
                <div class="items" v-for="(item, idx) in projectPortfolio" :key="idx"
                    @click="goToProjectDetail(item.id, item.program)">
                    <div style="height: 240px">
                        <img :src="item.image_url" :alt="item.program"
                            style="width: 100%; height: 100%; border-radius: 16px 16px 0 0;" />
                    </div>
                    <div class="content">
                        <div class="content-title">
                            <h2>{{ item.program }}</h2>
                        </div>
                        <p class="content-title-p">{{ item.title }}</p>
                        <p class="description-class">{{ item.description }}</p>
                    </div>
                </div>
            </div>
            <div class="empty-data" v-else>
                <img src="/img/empty_folder.png" alt="">
                <div class="empty-data-text">
                    <h3>{{ $t('emptyTitle') }}</h3>
                    <p>{{ $t('emptyDescription') }}</p>
                </div>
            </div>
            <v-row justify="center" class="mt-10" v-if="total > 1">
                <v-col cols="4">
                    <Pagination @pageChanged="onPageChanged" :currentPage="currentPage" :totalPages="total" />
                </v-col>
            </v-row>
        </div>
        <v-card elevation="0" class="call-center-container">
            <v-row style="padding: 40px 80px">
                <v-col cols="8">
                    <div class="call-center-title">
                        {{ $t('portfolioHelpTitle') }}
                    </div>
                    <div class="call-center-desc">
                        {{ $t('portfolioHelpDescription') }}
                    </div>
                </v-col>
                <v-col cols="1" />
                <v-col cols="3" class="call-center-button" @click="handleToCorporatePage">
                    <v-btn class="btn" elevation="0"> {{ $t('portfolioAct') }} </v-btn>
                </v-col>
            </v-row>
        </v-card>
    </div>
</template>

<script>
import Pagination from '@/components/others/Pagination.vue'

export default {
    name: "DesktopPortfolio",
    components: {
        Pagination
    },
    data() {
        return {
            projectPortfolio: [],
            currentPage: 1,
            total: 1,
            perPage: 12,
            currentCategory: "SERVICES",
            categoryList: [
                {
                    key: "SERVICES",
                    value: "Technology Service"
                },
                {
                    key: "COLLABORATION",
                    value: "Corporate Collaboration"
                },
                {
                    value: "Corporate Training",
                    key: "TRAINING",
                },
                {
                    key: "TALENT_SERVICE",
                    value: "Talent as a Service"
                },
            ],
        }
    },
    watch: {
        "$i18n.locale"() {
            this.getPortfolio();
        },
    },
    methods: {
        handleToCorporatePage() {
            this.$gtag.event('click', {
                event_category: 'Navigation',
                event_label: 'Redirect to Corporate Page - Portfolio Page',
                value: 1,
            });
            return this.$router.push("/corporate");
        },
        async getPortfolio(e) {
            const resp = await this.$http.get(`/v1/project-portfolio?category=${e}&page=${this.currentPage}&per_page=${this.perPage}`)
            this.projectPortfolio = resp.data.data.project_portfolios.filter((item) => item.category === e);
            let lengthData = this.projectPortfolio.length;
            if (lengthData) this.total = resp.data.data.total <= this.perPage ? 1 : Math.ceil(resp.data.data.total / this.perPage);
            this.currentCategory = e;
        },
        onPageChanged(page) {
            this.$gtag.event('click', {
                event_category: 'Interaction',
                event_label: `Change Page - Page ${page} - Portfolio Page`,
                value: 1,
            });
            this.currentPage = page;
            this.getPortfolio();
        },
        goToProjectDetail(id, program) {
            this.$gtag.event('click', {
                event_category: 'Navigation',
                event_label: `View Project Detail - ${program} - Portfolio Page`,
                value: 1,
            });
            this.$router.push(`/portfolio/detail/${id}`);
        }
    },
    mounted() {
        this.getPortfolio(this.currentCategory);
        this.$gtag.pageview(this.$route);
    }
}
</script>

<style scoped src="./portfolio.css"></style>